import { PublicBookingDto } from '@shared/core/bookings'
import ms from 'ms'
import { useQuery, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { BookingsService } from 'src/services/bookings.service'

// Cache key
export const GET_BOOKING_BY_ID_CACHE_KEY = 'get-booking-by-id'

// Get booking by ID
export function useBookingById(bookingId: string, options?: UseQueryOptions<PublicBookingDto | null>) {
  const handleRetry = useHandleRetry()
  return useQuery([GET_BOOKING_BY_ID_CACHE_KEY, bookingId], () => BookingsService.getBookingById(bookingId), {
    enabled: !!bookingId,
    staleTime: ms('5 minutes'),
    retry: handleRetry,
    ...options,
  })
}
